import React, { useState } from 'react';
import './SignupForm.css';
import { useNavigate } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';

import facebookLogo from './assets/Facebook.png';
import humanIcon from './assets/human-icon.png';

const SignupForm = ({ close, openLogin }) => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [referral, setReferral] = useState('');
  const [role, setRole] = useState('');
  const [emailError, setEmailError] = useState('');
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const emailPattern = /^[a-zA-Z0-9._%+-]+@gmail\.com$/;

  const handleSignup = (e) => {
    e.preventDefault();
    if (!role) {
      alert("Please select your role (Student, Mentor, or Admin)");
      return;
    }
    console.log("Sending to backend:", { name, email, password, role });
    fetch("https://kodez.robokalam.in/api/signup.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, email, password, role })
    })
      .then(res => res.json())
      .then(data => {
        console.log("Signup response:", data); // ✅ Debug output

        if (data.status === "success") {
          setShowSuccessPopup(true); // ✅ Show success popup
          localStorage.setItem("user", JSON.stringify({ name, email, role }));

          setTimeout(() => {
            setShowSuccessPopup(false);
            close?.();
            navigate(data.redirect || "/"); // ✅ Use backend redirect
          }, 2000); // 2 seconds so user sees the popup
        } else {
          alert(data.message || "Signup failed.");
        }
      })
      .catch(() => alert("Server error. Please try again."));
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      if (!role) {
        alert("⚠️ Please select your role before continuing with Google");
        return;
      }

      try {
        const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: {
            Authorization: `Bearer ${tokenResponse.access_token}`,
          },
        });
        const data = await res.json();
        console.log("Google user info:", data);

        const payload = {
          name: data.name || data.email.split('@')[0],
          email: data.email,
          password: data.sub,
          role,
          auth_provider: 'google',
        };

        const backendRes = await fetch("https://kodez.robokalam.in/api/google-signup.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        const backendData = await backendRes.json();
        console.log("Backend response:", backendData);

        if (backendData.status === "success") {
          localStorage.setItem("user", JSON.stringify(backendData.user));
          setShowSuccessPopup(true);
          setTimeout(() => {
            setShowSuccessPopup(false);
            close?.();
            navigate(backendData.redirect || "/dashboard");
          }, 2000);

          
        } else {
          alert(backendData.message || "Signup failed.");
        }
      } catch (error) {
        alert("❌ Google Sign-Up failed. Check console logs for details.");

      }
    },
    onError: () => alert("❌ Google Sign-Up failed."),
  });




  const togglePassword = () => setShowPassword(prev => !prev);
  const handleBack = () => close?.();

  return (
    <div className="signup-wrapper">
      {showSuccessPopup && (
        <div className="popup-message">
          Signup successful! Please log in with your credentials.
        </div>
      )}
      <div className="signup-box">
        <div className="back-button" onClick={handleBack}>
          <span className="arrow">←</span> Back
        </div>

        <div className="profile-icon">
          <img src={humanIcon} alt="user" className="profile-icon-img" />
        </div>

        <h4>Create your free account</h4>

        <form className="signup-form" onSubmit={handleSignup}>
          <input type="text" placeholder="Name" required value={name} onChange={e => setName(e.target.value)} />

          <div className={`input-wrapper ${emailError ? 'input-error' : ''}`}>
            <input
              type="email"
              placeholder="Email address"
              required
              value={email}
              onChange={e => setEmail(e.target.value)}
              onBlur={() => setEmailError(emailPattern.test(email) ? '' : 'Please enter a valid Gmail address')}
            />
            {emailError && <p className="error-text">{emailError}</p>}
          </div>

          <div className="password-wrapper">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              required
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            <span className="toggle-password" onClick={togglePassword}>
              <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
            </span>
          </div>

          <select required value={role} onChange={e => setRole(e.target.value)} style={{ marginTop: '12px', borderRadius: '20px', padding: '10px 14px', background: '#f9f9f9' }}>
            <option value="">Select Role</option>
            <option value="student">Student</option>
            <option value="mentor">Mentor</option>
            <option value="admin">Admin</option>
          </select>

          <input type="text" placeholder="Referral code (optional)" value={referral} onChange={e => setReferral(e.target.value)} />

          <button type="submit" className="signup-btn">Sign Up</button>

          <div className="separator">or</div>

          <div className="social-btn" style={{ padding: 0, border: 'none', overflow: 'hidden' }}>
            {/* <GoogleLogin
              onSuccess={(credentialResponse) => {
                if (!role) {
                  alert("⚠️ Please select your role before continuing with Google");
                  return;
                }

                const decoded = jwtDecode(credentialResponse.credential);


                const payload = {
                  name: decoded.name || decoded.email.split('@')[0],
                  email: decoded.email,
                  password: decoded.sub,  // use sub as dummy password
                  role,                   // selected from dropdown
                  auth_provider: "google" // 💥 new field
                };

                fetch("https://kodez.robokalam.in/api/google-signup.php", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify(payload)
                })
                  .then(res => res.json())
                  .then(data => {
                    if (data.status === "success") {
                      localStorage.setItem("user", JSON.stringify(data.user));
                      close?.();
                      navigate(data.redirect || "/dashboard");
                    } else {
                      alert(data.message || "Signup failed.");
                    }
                  })
                  .catch(() => alert("❌ Server error. Try again."));
              }}
              onError={() => alert("❌ Google Sign-Up failed.")}
            /> */}

            {/* Custom Google Sign-in Button */}
            <div
              className="custom-google-btn"
              onClick={() => {
                if (!role) {
                  alert("⚠️ Please select your role before continuing with Google");
                  return;
                }
                googleLogin();
              }}

              style={{
                cursor: 'pointer',
                padding: '12px',
                backgroundColor: '#fff',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}
            >
              <img src="https://developers.google.com/identity/images/g-logo.png" alt="Google" style={{ width: 20, marginRight: 10 }} />
              Sign in with Google
            </div>


          </div>

          <button type="button" className="social-btn" onClick={() => alert("Facebook signup coming soon.")}>
            <img src={facebookLogo} alt="Facebook" /> Sign up with Facebook
          </button>

          <p className="bottom-text">
            Already have an account? <span onClick={openLogin} className="login-link">Log in</span>
            <br />
            By continuing you agree to our&nbsp;
            <a href="https://learn.robokalam.com/termsofuse" target="_blank" rel="noreferrer">Terms of Service</a> and&nbsp;
            <a href="https://learn.robokalam.com/privacypolicy" target="_blank" rel="noreferrer">Privacy Policy</a>
          </p>

          <p className="support-text">
            Need help? <a href="mailto:team@robokalam.com">team@robokalam.com</a>
          </p>
        </form>
      </div>

      {/* {showSuccessPopup && (
        <div className="popup-message">
          Signup successful! Please log in with your credentials.
        </div>
      )} */}
    </div>
  );
};

export default SignupForm;
